import AppRoutes from "./routes/AppRoutes";
import AppHeader from "./components/AppHeader";
import { Box } from "@mui/material";

function App() {
  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          background: "#f8fafc",
        }}
      >
        <AppHeader />
        <AppRoutes />
      </Box>
    </>
  );
}

export default App;
